export const formatIsoDate = (date: Date): string =>
  date.toISOString().split('T')[0];
